module.exports = __webpack_public_path__ + "static/media/COLA2018003.d942515d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/PDFFiles/COLA2018003.pdf
// module id = 2571
// module chunks = 1